export enum CodeBustersFeatureFlags {
    CandidateProfileComponentAbout = 'CB_Candidate_Profile_Component_About',
    CandidatePhoneNumberRefactor = 'CB_Use_List_PhoneNumbers_Profile',
    ShowMissingReferencesAlert = 'CB_SHOW_MISSING_REFERENCES_ALERT',
    CertificationAndHistoryAlert = 'CB_CERTIFICATION_ALERT_AND_HISTORIES',
    WorkHistoryReferenceContactStatus = 'CB_WORK_HISTORY_REFERENCE_CONTACT_STATUS',
    TextEditorOverflowWrap = 'CB_TEXT_EDITOR_OVERFLOW_WRAP',
    WorkHistoryProfileAlert = 'CB_WORK_HISTORY_PROFILE_ALERT',
    ToggleShowExpiredReferences = 'cb-toggle-show-expired-references',
    ImproveCandidateAddition = 'cb-improve-candidate-addition',
    EnableNewSubmittalPage = 'cb-enable-new-submittal-page',
    DisplayPhoneAddressLastVerifiedHoverMessage = 'cb-display-phone-address-last-verified-hover-message',
    DisplayJobIdOnRecruiterLiveList = 'cb-display-job-id-on-recruiter-live-list',
    DeclineOfferCategory = 'decline-offer-reason-category',
    DisplayMiddleNameInCandidateProfile = 'cb-display-middle-name-in-candidate-profile'
}
